module.exports = __webpack_public_path__ + "static/media/background.abe824e3.png";